export const SERVER_URL = "https://do-calculate.com/api";

export const Money_Zakat_EndPoint = "calculate-money-zakat";
export const Gold_Zakat_EndPoint = "calculate-gold-zakat";
export const Gold_Karat_EndPoint = "calculate-gold-karat";
export const Silver_Zakat_EndPoint = "calculate-silver-zakat";
export const Fruits_Zakat_EndPoint = "calculate-fruits-zakat";
export const Trade_Zakat_EndPoint = "calculate-trade-zakat";
export const Animals_Zakat_EndPoint = "calculate-animals-zakat";
export const islamicCalculators = [
  {
    name: "حاسبة زكاة المال",
    link: "/calculator/ar/money-zakat/",
    description:
      "تستخدم هذه الحاسبة لحساب زكاة المال والصدقات بناءً على القواعد الإسلامية.",
      showMain: true
  },
  {
    name: "حاسبة زكاة الذهب",
    link: "/calculator/ar/gold-zakat/",
    description:
      "هذه الحاسبة تقوم بحساب زكاة الذهب والمجوهرات بناءً على الشروط الشرعية.",
      showMain: true
  },
  {
    name: "حاسبة زكاة الفضة",
    link: "/calculator/ar/silver-zakat/",
    description:
      "تستخدم هذه الحاسبة لحساب زكاة الفضة والمعادن الثمينة بناءً على الأحكام الإسلامية.",
      showMain: true
  },
  {
    name: "حاسبة زكاة الثمار",
    link: "/calculator/ar/fruits-zakat/",
    description:
      "هذه الحاسبة تقوم بحساب زكاة الثمار والمحصولات الزراعية وفقًا للأحكام الدينية.",
      showMain: true
  },
  {
    name: "حاسبة زكاة عروض التجارة",
    link: "/calculator/ar/trade-zakat/",
    description:
      "تستخدم هذه الحاسبة لحساب زكاة عروض التجارة والأموال الاستثمارية.",
      showMain: true
  },
  {
    name: "حاسبة زكاة الحيوانات",
    link: "/calculator/ar/animals-zakat/",
    description:
      "هذه الحاسبة تقوم بحساب زكاة الحيوانات والماشية بناءً على الأحكام الشرعية.",
  },
  {
    name: "حاسبة تحويل قراط الذهب",
    link: "/calculator/ar/gold-karat/",
    description:
      "تستخدم هذه الحاسبة لتحويل وحدة قراط الذهب إلى وحدات أخرى مثل الجرام والأوقية.",
      showMain: true
  },
  {
    name: "حاسبة صلاة التهجد",
    link: "/calculator/ar/tahajjud-time/",
    description:
      "تستخدم هذه الحاسبة لحساب وقت صلاة التهجد بناءً على أوقات صلاة المغرب والفجر.",
      showMain: true
  },
  // evening-athkar
  {
    name: "أذكار المساء",
    link: "/calculator/ar/athkar-almasaa/",
    description: "استعرض أذكار المساء مع عداد رقمي يساعدك على تتبع التسبيحات والأذكار اليومية بسهولة ويسر.",
  },
  // athkar-alsabah
  {
    name: "أذكار الصباح",
    link: "/calculator/ar/athkar-alsabah/",
    description: "استعرض أذكار الصباح مع عداد رقمي يساعدك على تتبع التسبيحات والأذكار اليومية بسهولة ويسر.",
  }, 
];
export default islamicCalculators;